import Axios from 'axios'
import { Notification } from 'element-ui'
export default {
  data() {
    return {
      notice: null, // 提醒弹窗
      timer: null, // 定时器
      currentUser: '',
      needInterval: false // 是否需要轮询
    }
  },
  async mounted() {
    window.document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  activated() {
    window.document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  beforeDestroy() {
    window.document.removeEventListener('visibilitychange', this.onVisibilityChange)
  },
  deactivated() {
    window.document.removeEventListener('visibilitychange', this.onVisibilityChange)
  },
  methods: {
    onVisibilityChange(e) {
      const visibilityState = e.target.visibilityState
      try {
        if (this.$route.path.match(/^\/im/)) {
          this.$libTrack.trace(`[IM]客服${visibilityState === 'visible' ? '进入了' : '离开了'}浏览器IM工作台页面`)
        }
        if (this.$route.path.match(/^\/callin/) || this.$route.path.match(/^\/tr_callin/)) {
          this.$libTrack.trace(`[callin]客服${visibilityState === 'visible' ? '进入了' : '离开了'}浏览器电话工作台页面`)
        }
      } catch (e) {
        console.error(e)
      }
      if (!this.needInterval) return
      if (!document.hidden) {
        this.checkWarningFn()
        this.intervalFn()
      } else {
        clearInterval(this.timer)
      }
    },
    intervalFn() {
      this.timer = setInterval(() => {
        this.checkWarningFn()
      }, 30000)
    },
    async checkWarningFn() {
      const { data } = await Axios(process.env.VUE_APP_API + '/crm-security-prewarning-app/prewarnCaseService/query', {
        method: 'POST',
        withCredentials: true
      })
      if (data.success) {
        if (this.notice) {
          this.notice.close()
        }
        const _data = data.data
        if (_data.warnReopenDTOList.length) {
          // 判断是否有重开弹窗
          // current 用于存储当前用户对象
          const current = _data.warnReopenDTOList.filter(item => {
            return item.userId == this.currentUser
          })
          if (current.length) {
            // tag是弹窗类型么
            if (current[0].tag == 1) {
              // 1： 强弹窗，其他若弹窗
              this.alertFn(false, true) // 0 标示新的告警单 1表示已认领或重开的报警单 指定当前处理人的
            } else {
              this.alertFn(true, true)
            }
            return
          }
        }
        if (_data.typeCount.ALARM && _data.typeCount.ALARM > 0) {
          this.alertFn(false, false)
        } else if (_data.typeCount.OTHER && _data.typeCount.OTHER > 0) {
          this.alertFn(true, false)
        }
      }
    },
    alertFn(showClose, personal) {
      // showClose: false 无关闭的强提醒； personal: 个人弹窗
      const _obj = {
        title: '预警单提醒',
        message: '有新的预警单, 请尽快 <a href="javascript:;" style="color: #1f5de9">前往处理</a>',
        duration: 0,
        offset: 100,
        dangerouslyUseHTMLString: true,
        onClick: () => {
          this.notice.close()
          // 如果是当前页就直接刷新，否则新 tab 页面打开列表页
          let url = `${process.env.VUE_APP_API}/crm-complaint-pc/#/warning`
          if (personal) {
            url += '?status=1'
          }
          window.open(url, '_blank')
        }
      }
      _obj.showClose = showClose
      _obj.type = showClose ? 'warning' : ''
      if (personal) {
        _obj.message = '您' + _obj.message
      }
      this.notice = Notification(_obj)
    }
  }
}
